export default __webpack_public_path__ + "static/media/186.0806d689.png";